import { render, staticRenderFns } from "./AgentNotifications.vue?vue&type=template&id=6f6a4ca2"
import script from "./AgentNotifications.vue?vue&type=script&lang=ts"
export * from "./AgentNotifications.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports